import { useTranslation } from "react-i18next";
import { Notice } from "@/components/Notice";
import type { Review, ReviewSentence } from "./review.ts";

/**
 * "Before you save" (openspec change classification-editor, design D5): every change of the
 * scheme in one plain sentence (a change that touches files adds what happens to them), in a
 * warning tone when anything loosens, or moves or tightens a level files use.
 */
export function ReviewBlock(props: { review: Review }) {
  const { t: typed } = useTranslation();
  // Keys computed from the change (review.ts): typed as plain strings.
  const t = typed as unknown as (key: string, values?: object) => string;
  const say = (sentence: ReviewSentence) => {
    const key = sentence.key.startsWith("adminSettings.")
      ? sentence.key
      : `adminSettings.levels.${sentence.key}`;
    const values = Object.fromEntries(
      Object.entries(sentence.values ?? {}).map(([name, value]) => [
        name,
        typeof value === "object" ? t(value.key) : value,
      ]),
    );
    return t(key, values);
  };
  return (
    <Notice
      tone={props.review.warning ? "warning" : "neutral"}
      title={t("adminSettings.levels.reviewTitle")}
      live
    >
      <ul className="flex list-disc flex-col gap-1 pl-4">
        {props.review.items.map((item) => {
          const text = item.sentences.map(say).join(" ");
          return <li key={text}>{text}</li>;
        })}
      </ul>
    </Notice>
  );
}
